import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionBannerService {

  parseHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private subscriptionBanners = new BehaviorSubject<any>({});
  subscriptionBannersObservable$ = this.subscriptionBanners.asObservable();
  private timePeriod?: Subscription;

  constructor(private http: HttpClient) {}

  public fetchSubscriptionBillingAlertsBanners() {
    const stored = localStorage.getItem('SubscriptionBanners');

    if (stored) {
      const parsed = JSON.parse(stored);

      if (parsed.lastFetchedAt && !this.isCacheExpired(parsed.lastFetchedAt)) {
        //Using cached feature flags
        this.subscriptionBanners.next(parsed);
        return;
      }
    }

    this.getSubscriptionBillingAlertsBanners().subscribe((res: any) => {
      if (res?.Result == "Success" && res?.ResponseData?.length) {
        const data = res?.ResponseData;
  
        const updatedDataWithTimeStamp = {
          banners: data,
          lastFetchedAt: new Date().toISOString()
        }

        localStorage.setItem('SubscriptionBanners', JSON.stringify(updatedDataWithTimeStamp));
        this.subscriptionBanners.next(updatedDataWithTimeStamp);
      } else {
        this.subscriptionBanners.next([]);
      }
    });
  }

  public getSubscriptionBillingAlertsBanners() {
    const url =  environment.subscriptionApiBaseUrl + '/SubscriptionApi/GetSubscriptionBillingAlerts';
    return this.http.get(url, this.parseHeaders);
  }

  private isCacheExpired(lastFetchedAt: string): boolean {
    const lastDate = new Date(lastFetchedAt);
    const now = new Date();

    // Check if the calendar date (year, month, day) has changed
    return (
      lastDate.getFullYear() !== now.getFullYear() ||
      lastDate.getMonth() !== now.getMonth() ||
      lastDate.getDate() !== now.getDate()
    );
  }

  public callSubscriptionBannerAlertWithoutCache() {
    this.getSubscriptionBillingAlertsBanners().subscribe((res: any) => {
      if (res?.Result == "Success" && res?.ResponseData?.length) {
        const data = res?.ResponseData;
  
        const updatedDataWithTimeStamp = {
          banners: data,
          lastFetchedAt: new Date().toISOString()
        }

        localStorage.setItem('SubscriptionBanners', JSON.stringify(updatedDataWithTimeStamp));
        this.subscriptionBanners.next(updatedDataWithTimeStamp);
      } else {
        this.subscriptionBanners.next([]);
      }
    });
  }

  public getSeverity(severity: string): string {
    switch (severity?.toLowerCase()) {
      case 'success': return 'success';
      case 'info': return 'info';
      case 'warn':
      case 'warning': return 'warning';
      case 'error':
      case 'danger': return 'danger';
      default: return 'info';
    }
  }

  public getBannerColor(severity: string): string {
    switch (severity?.toLowerCase()) {
      case 'danger': return '#d32f2f'; 
      case 'warning': return '#ffa726'; 
      case 'info': return '#1976d2'; 
      case 'success': return '#388e3c'; 
      default: return '#1976d2';
    }
  }

  public getSeverityIcon(severity: string): string {
    switch (severity?.toLowerCase()) {
      case 'danger': return 'bi-exclamation-triangle';
      case 'warning': return 'bi-exclamation-triangle';
      case 'info': return 'bi-exclamation-circle';
      case 'success': return 'bi-check-circle';
      default: return 'bi-exclamation-circle';
    }
  }
}
